module.exports = __webpack_public_path__ + "img/sidebar-active.b68342c.webp";